import { useEffect, useRef, useState } from 'react';
import {
  Box,
  Icon,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Paper,
  Tooltip,
  Typography,
} from '@mui/material';
import Loader from 'components/Loader';
import styles from './styles';

const Stepper = ({
  icon,
  fetch,
  index,
  titulo,
  loading,
  actions,
  tooltip,
  renderComponent,
}) => {
  const lastScrollTop = useRef(0);
  const [page, setPage] = useState(0);
  const [itens, setItens] = useState([]);
  const [selected, setSelected] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [options, setOptions] = useState(null);

  useEffect(() => {
    onFetch();
  }, []);

  const onFetch = () => {
    const cb = (res) => {
      setItens((prev) => (Boolean(page) ? [...prev, ...res] : res));
      setPage((prev) => prev + 1);
      if (res?.length < 10) {
        setHasMore(false);
      }
    };

    fetch({ page }, cb);
  };

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    const isScrollingDown = scrollTop > lastScrollTop.current;
    lastScrollTop.current = scrollTop;
    const diff = scrollHeight - scrollTop - clientHeight < 100;

    if (isScrollingDown && diff && !loading && hasMore) {
      onFetch();
    }
  };

  const handleSelect = (item) => {
    if (selected?.some((s) => s?.id === item?.id)) {
      setSelected((prev) => prev?.filter((f) => f?.id !== item?.id));
    } else {
      setSelected((prev) => [...prev, item]);
    }
  };

  const handleOptions = (e) =>
    setOptions({ actions, selected, anchorEl: e?.currentTarget });

  const renderActions = () =>
    options?.actions?.map(
      ({ action, icon, name, show }, index) =>
        Boolean(show) && (
          <MenuItem
            key={index?.toString()}
            disabled={!options?.actions}
            onClick={() => {
              setOptions(null);
              if (action) action(options?.selected);
            }}
          >
            {icon && (
              <ListItemIcon>
                <Icon>{icon}</Icon>
              </ListItemIcon>
            )}
            {name}
          </MenuItem>
        )
    );

  return (
    <Paper sx={styles?.stepContainer} elevation={3} onScroll={handleScroll}>
      <Box sx={styles?.header}>
        <Tooltip title={tooltip}>
          <Icon sx={styles?.icon}>{icon}</Icon>
        </Tooltip>
        <Typography flex={1} variant="h6" color="primary.white" ml={2}>
          {titulo}
        </Typography>
        {Boolean(actions?.length) && (
          <IconButton sx={styles?.icon} size="small" onClick={handleOptions}>
            <Icon>more_vert</Icon>
          </IconButton>
        )}
      </Box>
      {renderComponent({ itens, index, selected, handleSelect })}
      {Boolean(loading) && <Loader />}
      <Menu
        id="basic-menu"
        anchorEl={options?.anchorEl}
        open={Boolean(options?.anchorEl)}
        onClose={() => setOptions(null)}
      >
        {renderActions()}
      </Menu>
    </Paper>
  );
};

export default Stepper;
